import { useContext } from "react";

import { permissionsContext } from "../config";
import type { IPermissionsContext } from "../types";
import { Logger } from "utils/logger";

const usePermissions = (): IPermissionsContext => {
  const all = useContext(permissionsContext);

  if (all === undefined) {
    Logger.warning("Permissions context not found");
  }

  return all as IPermissionsContext;
};

export { usePermissions };
